import type { InjectionKey } from "vue";
import type { DSFormStore } from "../store/dsFormStore";
import { DS_CUSTOM_ELEMENT_NAME, customElementTag } from "@/src/design_system/shared/constants/customElementNames";

export const DS_FORM_STORE_PROVIDE_KEY: InjectionKey<DSFormStore> = Symbol("ds-form-store");

export const DS_FORM_STORE_DOM_KEY = "__dsFormStore" as const;

export const DS_FORM_CUSTOM_ELEMENT_SELECTOR = customElementTag(DS_CUSTOM_ELEMENT_NAME.Form);
